// Функци From DTO берет сырые данные с бека и превращает их в данные котоые хочет видеть фронт
export function geoZoneFromDtoService(dto, meta) {
  const { status } = meta.response;

  return { data: dto, status };
}

export default geoZoneFromDtoService;
